import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { useMemo } from 'react';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
} from 'reactstrap';

import Navigator from 'src/components/Navigator';
import DocumentManager from 'src/modules/3rd-party-management/components/document-management';
import {
    ROUTE_PATH_THIRDPARTY_HOME,
    ROUTE_PATH_THIRD_PARTY_DOCUMENTS,
} from 'src/modules/3rd-party-management/constants';

const Documents = ({
    t,
    organization,
}) => {
    const navigatorOptions = useMemo(() => ({
        translate: false,
        breadCrumbs: [
            {
                title: t('SIP'),
                link: ROUTE_PATH_THIRDPARTY_HOME,
            },
            {
                title: t('Documents'),
                link: ROUTE_PATH_THIRD_PARTY_DOCUMENTS,
            },
        ],
        pageTitle: t('Documents'),
    }), [t]);

    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator {...navigatorOptions} />
                    </Col>
                </Row>
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <DocumentManager
                                    supplierId={organization?.id}
                                    thirdPartyMode
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

const mapStateToProps = (state) => ({
    organization: state.Organization,
});

export default withNamespaces()(
    connect(mapStateToProps)(Documents)
);
